import IPPageNumber from "app/pages/InteractiveProposal/InteractiveProposalDownload/IPPageNuber";
import HexagonImg from "app/pages/InteractiveProposal/images/hexagonImg.png";
import { getSessionStore } from "app/utils/sessionStore";
import { createGradient, formatToCompactNumber, getThemeColors } from "app/utils/utils";
import { Chart } from "primereact/chart";
import { lineChartOptions } from "app/uicomponents/macrocomponents/PlansSummary/config";
import type { ChartDataset } from "./IRCFundingPage";

interface IRCProjectionChartsPageProps {
  chartLabels: (string | number)[];
  chartDatasets: ChartDataset[];
  pageNumber: string | number;
}

const IRCProjectionChartsPage = ({
  chartLabels,
  chartDatasets,
  pageNumber,
}: IRCProjectionChartsPageProps) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { ipTooltipColor } = getThemeColors(branding);

  const makeLineData = (ds: ChartDataset) => ({
    labels: chartLabels,
    datasets: [
      {
        label: ds.label,
        fill: true,
        borderColor: ds.backgroundColor,
        backgroundColor: (context: any) => createGradient(context, ds.backgroundColor),
        yAxisID: "y",
        tension: 0.4,
        data: ds.data,
      },
    ],
  });

  const ChartCard = ({ ds }: { ds: ChartDataset }) => (
    <div>
      <div className="flex justify-between conthrax-font mb-1">
        <p className="font-bold text-gray-800 text-xs">{ds.label}</p>
        <span className="text-xs font-bold text-gray-500">
          ${formatToCompactNumber(ds.data.length > 0 ? ds.data[ds.data.length - 1] : 0)}
        </span>
      </div>
      <Chart
        type="line"
        height="170px"
        data={makeLineData(ds)}
        options={lineChartOptions(false, ipTooltipColor, "Plan Year", "Plan Year")}
      />
    </div>
  );

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20 px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        <h1 className="text-center text-2xl font-bold mb-4 conthrax-font interactive-proposal-text">
          Plan Projections
        </h1>

        {chartDatasets.map((ds, i) => (
          <div key={i} className={i < chartDatasets.length - 1 ? "mb-4" : ""}>
            <ChartCard ds={ds} />
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{ backgroundImage: `url(${HexagonImg})` }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default IRCProjectionChartsPage;
